module.exports = {
  BookingNo: 'Номер заказа',
  JobNo: 'Номер операции',
  ContainerLoadType: 'Тип консолидации',
  Electric: 'Содержит ли батареи',
  ElectricCol: 'С бат.',
  Magnetic: 'Содержит ли магнитные материалы',
  MagneticCol: 'С магнитными материалами',
  Powdery: 'Содержит ли Пор.',
  PowderyCol: 'Пор.',
  Liquid: 'Содержит ли Жидк.',
  LiquidCol: 'Жидк.',
  DomesticWarehouse: 'Склад получения',
  PreAmazonWhTime: 'Ожидаемое время поступления на склад Amazon',
  ServiceChannel: 'Сервисный канал',
  WarehouseCode: 'Код зарубежного склада',
  RemoteWarehouse: 'Удаленный ли склад',
  ShippingType: 'Способ транспортировки',
  DestinationDistribution: 'Способ доставки в пункте назначения',
  overseaWarehouse: 'Зарубежный склад',
  IncoTerm: 'Торговые условия',
  PoNumber: 'PO (оригинальный номер заказа)',
  ShipmentId: 'ID отгрузки',
  ReferenceId: 'Референсный ID',
  ChargingMethod: 'Способ тарификации',
  LclMethod: 'Способ консолидации',
  ValueAddedServices: 'Доп. усл.',
  EoriNo: 'EORI/Регистрационный номер компании',
  TaxnoType: 'Тип налогового номера',
  VatNo: 'НДС/Налоговый номер',
  TaxRegisterCountry: 'Страна регистрации НДС',
  TaxRegisterAddress: 'Адрес регистрации НДС',
  TaxCompany: 'Компания по НДС (на английском)',
  PreWarehousingTime: 'Ожидаемое время поступления на склад',
  QuantityContract: 'Общее количество мест (заказ)',
  WeightContract: 'Общий вес (заказ)',
  CubageContract: 'Общий объем (заказ)',
  VolumetricWeight: 'Габаритный объем (заказ)',
  ChargedWeight: 'Тарифный вес (заказ)',
  QuantityActual: 'Общее количество мест (факт)',
  WeightActual: 'Общий вес (факт)',
  CubageActual: 'Общий объем (факт)',
  QuantityCharge: 'Общее количество мест (тарификация)',
  WeightCharge: 'Общий вес (тарификация)',
  CubageCharge: 'Общий объем (тарификация)',
  BubbleCountingRatio: 'Коэффициент объемного веса',
  BubbleSplittingRatio: 'Доля объемного веса',
  PickupService: 'Забор груза',
  PickupTime: 'Время забора груза',
  PickupDoor: 'Пункт забора груза',
  DoorMan: 'Контактное лицо',
  DoorManTel: 'Контактный телефон',
  DoorAddress: 'Адрес пункта',
  CustomerRequire: 'Требования клиента',
  SubmitState: 'Статус отправки',
  SubmitBy: 'Отправитель',
  importSingleOrder: 'Импорт отдельного заказа',
  batchImportOrder: 'Импорт пакетных заказов',
  downloadSingleImportTemplate: 'Скачать шаблон для импорта отдельного заказа',
  downloadBatchImportTemplate: 'Скачать шаблон для импорта пакетных заказов',
  SubmitDate: 'Время отправки',
  VerifyState: 'Статус предварительной проверки',
  VerifyBy: 'Предварительный проверяющий',
  VerifyDate: 'Время предварительной проверки',
  UseNewNo: 'Создать новый бизнес-номер',
  BookingAudit: 'Проверка заказа',
  ShippingTypeCannotBeEmpty: 'Способ транспортировки не может быть пустым',
  ChargingMethodCannotBeEmpty: 'Способ расчета не может быть пустым',
  DomesticWarehouseCannotBeEmpty: 'Склад получения не может быть пустым',
  WarehouseCodeCannotBeEmpty: 'Номер склада Amazon не может быть пустым',
  ContainerLoadTypeCannotBeEmpty: 'Тип консолидации не может быть пустым',
  OperateTypeCannotBeEmpty: 'Режим работы не может быть пустым',
  BookingTermCannotBeEmpty: 'Характер бронирования не может быть пустым',
  VerifyRefuseReason: 'Причина отказа при проверке',
  ReverifyRefuseReason: 'Причина отказа при повторной проверке',
  CustomerId: 'Доверительная организация',
  LoadingPortCode: 'Порт отправления',
  Packing: 'Тип упаковки',
  SingleImport: 'Импорт заказа FBA',
  Op: 'Действие',
  Sales: 'Продажи',
  Csr: 'Обслуживание клиентов',
  Dc: 'Документация',
  CreatedBy: 'Создатель',
  DateCreated: 'Дата создания',
  ExpressCompany: 'Курьерская компания',
  ExpressNo: 'Номер почтового отправления',
  AmazonWarehouseCode: 'Код склада Amazon',
  OperationStatusOfForeignWarehouse: 'Статус работы зарубежного склада',
  Cargo_PolStation: 'Станция отправления (железная дорога)',
  quotationStatus: 'Статус предложения',
  quotationObject: 'Объект предложения',
  hasJob: 'Вводить ли заказ',
  cannotDeleteAddedService: 'Нельзя удалить дополнительные услуги, уже используемые в бизнесе!',
  changeChannel: 'Текущий сервисный канал не поддерживает предложения для текущего уровня клиента, система не может автоматически оценить расходы. Продолжить?',
  cargoTypeNotExist: 'Текущий сервисный канал не принимает грузы типа {0}, обновите тип груза!',
  warehouseCodeNotExist: 'Текущий сервисный канал не обслуживает пункт назначения {0}, обновите пункт назначения!',
  changeWarehouseCode: 'Пункт назначения изменен, обновить ли расходы, сгенерированные в зоне исходного сервисного канала?',
  changeCustomer: 'Доверительная организация изменена, обновить ли расходы, сгенерированные для уровня клиента исходного сервисного канала?',
  changeChargeWeight: 'Расчетный вес изменен, обновить ли расходы, рассчитанные по расчетному весу? Расходы, по которым уже выставлены счета, проведены платежи или списания, не будут обновлены',
  refreshCharge: 'Сервисный канал изменен, обновить ли расходы, сгенерированные по исходному сервисному каналу?',
  channelInfoCannotChange: '{0} данного канала обслуживания нельзя изменить.',
  changeVerifyShippingType: '{0} Данный канал обслуживания поддерживает только {1} транспортировку.',
  changeVerifyMultipleShippingType: 'Для заказов, содержащих каналы обслуживания в выбранных данных, нельзя изменить способ доставки.',
  otherOverseaWarehouse: 'Зарубежный склад третьей стороны'
}
